import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { MapPinIcon } from 'lucide-react';
import type { Aop, Territory } from '../../types/dashboard';
import { aopZips } from '../../utils/territory';
import { AOP_PALETTE } from '../../utils/theme';
import { Panel } from '../ui/Panel';
export function AopZipPanel({
  territory,
  selectedAop
}: {
  territory: Territory;
  selectedAop?: Aop;
}) {
  const navigate = useNavigate();
  const {
    search
  } = useLocation();
  const listAops = selectedAop ? [selectedAop] : territory.aops;
  return <Panel title={selectedAop ? `${selectedAop.name} ZIP codes` : 'AOP ZIP codes'} subtitle="An AOP is the 10–15 minute drive time around a venue where a program is marketed, defined by ZIP codes in i9 Sports Connect. Shows current ZIP assignment only — availability of historical ZIP-to-AOP records is pending validation, so past months are not re-attributed here." data-id="element-570" data-mp="673bb546naez">
      <div className="grid grid-cols-2 gap-2 rounded-md bg-canvas p-2.5" role="img" aria-label="Schematic map of AOP ZIP code clusters" data-id="element-571" data-mp="1qkc47iq8utwq">
        {territory.aops.map((a, idx) => {
        const color = AOP_PALETTE[idx % AOP_PALETTE.length];
        const dim = selectedAop && selectedAop.id !== a.id;
        return <button key={a.id} type="button" onClick={() => navigate(`/territory/${territory.id}/aop/${a.id}${search}`)} className={`rounded-md border bg-white p-2 text-left transition-opacity duration-150 hover:opacity-100 ${dim ? 'border-line opacity-45' : 'border-line-strong'} ${territory.aops.length === 3 && idx === 2 ? 'col-span-2' : ''}`} data-id="element-572" data-mp="6pdohtmcjj7u" data-mpi={idx}>
              <div className="mb-1.5 flex items-center gap-1 text-[11px] font-semibold text-ink" data-id="element-573" data-mp="3owkzg1trv4b6">
                <MapPinIcon className="h-3 w-3" style={{
              color
            }} data-id="element-574" data-mp="2rhp4nojckoab" />
                {a.name}
              </div>
              <div className="flex flex-wrap gap-1" data-id="element-575" data-mp="2wg0jkdoi1oze">
                {aopZips(a).map(z => <span key={z} className="h-4 w-6 rounded-[2px]" style={{
              background: color,
              opacity: 0.25 + Number(z) % 7 / 7 * 0.6
            }} title={z} data-id="element-576" data-mp="2ofc9dqxt3its" />)}
              </div>
            </button>;
      })}
      </div>
      <p className="mt-1.5 text-[11px] text-ink-subtle" data-id="element-577" data-mp="2y4vvr6kq9ute">Schematic view, not to geographic scale. Tile shade has no data meaning.</p>
      <div className="mt-4 space-y-3" data-id="element-578" data-mp="25h026aqggj0u">
        {listAops.map(a => <div key={a.id} data-id="element-579" data-mp="25h8f22mkvoc1">
            <div className="flex items-baseline justify-between text-xs" data-id="element-580" data-mp="20hwxiree0ete">
              <span className="font-semibold text-ink" data-id="element-581" data-mp="20jzw3ztlvg9q">{a.name}</span>
              <span className="text-ink-subtle" data-id="element-582" data-mp="2ffxnz5whxyg5">{a.venue}</span>
            </div>
            <div className="mt-1.5 flex flex-wrap gap-1" data-id="element-583" data-mp="2aftew0xx45zy">
              {aopZips(a).map(z => <span key={z} className="rounded border border-line bg-white px-1.5 py-0.5 text-[11px] tabular-nums text-ink-muted" data-id="element-584" data-mp="3qtjlpfgf98da">{z}</span>)}
            </div>
          </div>)}
      </div>
    </Panel>;
}